import { z } from 'zod';

export const missingDailyRevenueParametersSchema = z
	.strictObject({
		startDate: z.iso.date(),
		endDate: z.iso.date(),
		includePending: z.boolean().default(false),
		organizationId: z.number().int().positive().optional(),
	})
	.superRefine((value, ctx) => {
		if (value.endDate < value.startDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endDate'],
				message: 'End date must be on or after start date',
			});
		}
	});

export type MissingDailyRevenueParameters = z.infer<typeof missingDailyRevenueParametersSchema>;
